import { useStateMachine } from "little-state-machine";

export const useIsPinned = (sku: string): boolean => {
  const { state } = useStateMachine();
  return state.pinnedProductDetails?.some((p) => p.sku === sku) ?? false;
};